import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from '@iconify/react';
import { Accordion, AccordionDetails, AccordionSummary, Box, Drawer, IconButton, Typography, useMediaQuery, useTheme } from '@mui/material';
import { Cancel01Icon } from 'hugeicons-react';
import useTranslate from '../../../../../localization/helpers';
import RichText from '../../../../components/RichText';
var ChatFaqs = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, faqs = _a.faqs;
    var theme = useTheme();
    var translate = useTranslate().translate;
    var isXs = useMediaQuery(theme.breakpoints.only('xs'));
    var isSm = useMediaQuery(theme.breakpoints.only('sm'));
    return (_jsxs(Drawer, { slotProps: {
            paper: {
                sx: {
                    width: { sm: '400px', xs: '100%' },
                    height: { sm: 'calc(100vh - 24px)', md: 'calc(100vh - 24px)', xs: '100%' },
                    overflow: 'hidden'
                }
            }
        }, anchor: isXs ? 'bottom' : isSm ? 'right' : 'right', variant: 'temporary', open: isOpen, children: [_jsxs(Box, { sx: {
                    display: 'flex',
                    width: '100%',
                    borderRadius: '16px',
                    justifyContent: 'space-between',
                    padding: '16px 20px 2px 20px'
                }, children: [_jsx(Typography, { variant: 'h6', sx: { color: '#161C24' }, children: translate('faqs.faqDetails') }), _jsx(IconButton, { onClick: onClose, children: _jsx(Cancel01Icon, {}) })] }), _jsxs(Box, { sx: {
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '0px 20px 0px 20px',
                    width: '100%',
                    borderRadius: '16px',
                    gap: '12px',
                    overflowY: 'auto',
                    paddingBottom: '50px'
                }, children: [_jsx(Box, { children: _jsx(Typography, { variant: 'body1', sx: { color: '#161C24' }, children: !!faqs.length && faqs[0].machineName }) }), _jsx(Box, { sx: { width: '100%' }, children: _jsx(Box, { mt: 1, display: 'flex', flexDirection: 'column', gap: '12px', maxHeight: 'calc(100svh - 214px)', children: faqs.map(function (faq) {
                                var _a;
                                return (_jsx(Box, { children: _jsxs(Accordion, { sx: {
                                            width: '100%',
                                            zIndex: 1,
                                            boxShadow: 'none',
                                            borderTop: '1px solid rgba(145, 158, 171, 0.2)',
                                            borderBottom: '1px solid rgba(145, 158, 171, 0.2)',
                                            '&.Mui-expanded': {
                                                borderTop: 'none',
                                                borderBottom: 'none'
                                            }
                                        }, disableGutters: true, children: [_jsx(AccordionSummary, { expandIcon: _jsx(Icon, { icon: 'eva:arrow-ios-downward-fill' }), sx: {
                                                    backgroundColor: 'white',
                                                    '.MuiAccordionSummary-content': {
                                                        my: { md: 1.5, xs: 0.5 }
                                                    }
                                                }, children: _jsx(Typography, { variant: 'subtitle2', children: faq.question }) }), _jsx(AccordionDetails, { children: _jsx(RichText, { content: (_a = faq.answer) !== null && _a !== void 0 ? _a : '' }) })] }) }, faq.id));
                            }) }) })] })] }));
};
export default ChatFaqs;
